import { Box, Typography } from "@mui/material";
import { DefaultBadge } from "../../atoms/StatusBadge";
import { useRatingLevelOption } from "../../hooks/useRatingLevelOptions";
import { RectangularLoader } from "../skeleton-loader/RectangularLoader";

type RatingLevelReadOnlyCustomFieldProps = {
  value: string;
  maxWidth?: string;
};

export const RatingLevelReadOnlyCustomField = ({
  value,
  maxWidth = "325px",
}: RatingLevelReadOnlyCustomFieldProps) => {
  const { data: ratingLevel, isLoading } = useRatingLevelOption(value);

  return isLoading ? (
    <RectangularLoader height="20px" width="100%" />
  ) : (
    <DefaultBadge value={ratingLevel?.name ?? ""} maxWidth={maxWidth} />
  );
};
